/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-01-22 08:44:05
 * @LastEditTime: 2025-03-26 09:46:47
 * @LastEditors: ywj@originqc.com
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter} from 'react-router-dom';
import { Provider } from 'react-redux'
import { store } from './redux/store'
import reportWebVitals from './reportWebVitals';
import Layout from './components/layout';
import { ConfigProvider } from 'antd';
import zhCn from 'antd/locale/zh_CN';
import 'antd/dist/reset.css';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
      <ConfigProvider locale={zhCn}>
          <Layout />
      </ConfigProvider>
      </Provider>
    </BrowserRouter>
//  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
